import { RecordDto } from "@/core/common/entities/record.dto";
import { checklistTranslate } from "@/core/features/checklists/translations/checklist.translate";
import { get } from "lodash";
import {
  getReviewPeriodLabel,
  ReviewPeriodEnum,
  getChecklistRecordLabel,
  ChecklistRecordTypeEnum,
  getQuestionAnswerTypeLabel,
  QuestionAnswerType,
} from "@altertec_gparn/lib";
import { questionTranslate } from "@/core/features/checklists/translations/question.translate";

export class ChecklistRecordDto extends RecordDto {
  checklistId: string;
  translateEntityName = "la checklist";
  translateKeys = { ...checklistTranslate, ...questionTranslate };

  // @Override
  getTargetField(): string {
    if (!this.targetField) return;
    return get(this.translateKeys, this.targetField, this.targetField);
  }

  // @Override
  transformFn(value: unknown, originalValue: unknown): string {
    if (this.targetField === "isActive") {
      return Number(originalValue) ? "activo" : "inactivo";
    }

    if (this.targetField === "reviewPeriod") {
      return getReviewPeriodLabel(originalValue as ReviewPeriodEnum).toLowerCase();
    }

    if (this.targetField === "answerType") {
      return getQuestionAnswerTypeLabel(originalValue as QuestionAnswerType).toLowerCase();
    }

    return super.transformFn(value, originalValue);
  }

  // @Override
  getSubtype(): string {
    return getChecklistRecordLabel(this.subtype as ChecklistRecordTypeEnum, "checklist");
  }
}
